import { render, staticRenderFns } from "./HomeSVG.vue?vue&type=template&id=ccb4fc56&"
import script from "./HomeSVG.vue?vue&type=script&lang=js&"
export * from "./HomeSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports